import React from 'react';
import { useLocation } from 'react-router-dom';
import './halloweenTheme.css';

/**
 * Seasonal overlay. Motion is adapted from reviewed CodePens:
 * - floating ghost bob: https://codepen.io/ashwinlagji/pen/NemQZP
 * - corner web (static; the swinging spider on https://codepen.io/aitchiss/pen/BaKowbe was too busy here)
 * - small bat body and wing flap: https://codepen.io/Gregklotzwolf/pen/EaPqLpO
 * - walking figure: https://codepen.io/khadkamhn/pen/OyEZRz
 * Decorations do not receive pointer events.
 */
function SpiderWeb({ className }) {
  return (
    <svg className={className} viewBox="0 0 160 160" aria-hidden="true">
      <g fill="none" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round">
        <path d="M4 4 L156 28" />
        <path d="M4 4 L156 78" />
        <path d="M4 4 L148 156" />
        <path d="M4 4 L78 156" />
        <path d="M4 4 L22 156" />
        <path d="M28 10 Q48 36 12 46" />
        <path d="M52 16 Q86 62 18 86" />
        <path d="M78 22 Q122 96 26 124" />
        <path d="M104 28 Q146 124 36 150" />
      </g>
    </svg>
  );
}

function Ghost({ className }) {
  return (
    <svg className={className} viewBox="0 0 64 80" aria-hidden="true">
      <path
        fill="currentColor"
        d="M32 4c-15 0-26 12-26 28v40l9-8 8 8 9-9 9 9 8-8 9 8V32C58 16 47 4 32 4z"
      />
      <circle cx="23" cy="32" r="4.2" fill="#2a1838" />
      <circle cx="41" cy="32" r="4.2" fill="#2a1838" />
      <circle cx="24.4" cy="30.6" r="1.3" fill="#fff" />
      <circle cx="42.4" cy="30.6" r="1.3" fill="#fff" />
    </svg>
  );
}

function Bat({ className }) {
  return (
    <svg className={className} viewBox="0 0 120 48" aria-hidden="true">
      <path
        className="bqa-halloween__wing bqa-halloween__wing--left"
        fill="currentColor"
        d="M58 26 C46 22 30 10 8 16 C22 18 28 28 20 34 C32 32 44 30 58 32 Z"
      />
      <path
        className="bqa-halloween__wing bqa-halloween__wing--right"
        fill="currentColor"
        d="M62 26 C74 22 90 10 112 16 C98 18 92 28 100 34 C88 32 76 30 62 32 Z"
      />
      <ellipse cx="60" cy="28" rx="6" ry="8" fill="currentColor" />
      <circle cx="58" cy="26" r="1.1" fill="#f3e7ff" />
      <circle cx="63" cy="26" r="1.1" fill="#f3e7ff" />
    </svg>
  );
}

function LittleHalloween() {
  return (
    <div className="bqa-little">
      <div className="bqa-little-figure">
        <div className="bqa-little-head">
          <div className="bqa-little-skull">
            <div className="bqa-little-eyes">
              <div className="bqa-little-eye bqa-little-eye-left" />
              <div className="bqa-little-eye bqa-little-eye-right" />
            </div>
          </div>
        </div>
        <div className="bqa-little-body" />
        <div className="bqa-little-legs" />
      </div>
    </div>
  );
}

export default function HalloweenTheme() {
  const { pathname } = useLocation();
  const showWalker = !pathname.startsWith('/auth');

  return (
    <>
      <div className="bqa-halloween" aria-hidden="true">
        <div className="bqa-halloween__glow" />
        <SpiderWeb className="bqa-halloween__web bqa-halloween__web--left" />
        <SpiderWeb className="bqa-halloween__web bqa-halloween__web--right" />
        <Ghost className="bqa-halloween__ghost bqa-halloween__ghost--a" />
        <Ghost className="bqa-halloween__ghost bqa-halloween__ghost--b" />
      </div>
      <div className="bqa-halloween-bats" aria-hidden="true">
        <Bat className="bqa-halloween__bat bqa-halloween__bat--a" />
        <Bat className="bqa-halloween__bat bqa-halloween__bat--b" />
      </div>
      {showWalker && <LittleHalloween />}
    </>
  );
}
